module.exports = __webpack_public_path__ + "img/im_scrollfeature_03.73771bbf.jpg";